import React, { useState, useEffect } from "react";

// Components
import Main from "./TbSetItem/Main";
import Form from "./TbSetItem/Form";

// Utils
import { getDataWithComp, getAlert } from "../../../utils/SamuiUtils";
import { InitialDataTbSetItem } from "../../../model/InitialData/InitialDataTbSetItem";
import Navbar from "../../components/Modal/Navbar";

const TbSetItem = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataTbSetItem());

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_Employee ทั้งหมด
      const masterList = await getDataWithComp(
        "View_Set_Item",
        "Order BY Item_Code ASC"
      );
      const Stock = await getDataWithComp(
        "API_1101_WH_ITEM_ONHAND" 
      );
      if (masterList && masterList.length > 0) {
        const stockByItemId = (Stock || [])
          .filter((s) => parseInt(s.WH_Id, 10) === 5)
          .reduce((acc, cur) => {
            acc[cur.Item_Id] = cur.Item_Onhand ?? 0;
            return acc;
          }, {});

        const enriched = masterList.map((item) => ({
          ...item,
          stock: stockByItemId[item.Item_Id] ?? 0,
        }));

        enriched.sort((a, b) => a.Item_Code.localeCompare(b.Item_Code));
        setDataMasterList(enriched);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    console.debug("item", item);
    setMode("U");
    setFormData({
      item_id: item.Item_Id,
      comp_id: item.Comp_Id,
      item_barcode: item.Item_Barcode,
      item_code: item.Item_Code,
      item_name: item.Item_Name,
      item_name_en: item.Item_Name_EN,
      item_short_name: item.Item_Short_Name,
      item_unit_in: item.Item_Unit_IN,
      item_unit_st: item.Item_Unit_ST,
      item_unit_out: item.Item_Unit_OUT,
      item_cost: item.Item_Cost,
      item_price: item.Item_Price,
      item_pricea: item.Item_PriceA,
      item_priceb: item.Item_PriceB,
      item_brand: item.Item_Brand,
      item_series: item.Item_Series,
      item_group: item.Item_Group,
      item_cat: item.Item_Cat,
      item_colour: item.Item_Colour,
      item_size: item.Item_Size,
      item_status: item.Item_Status,
      item_popoint: item.Item_PoPoint,
      item_maxonhand: item.Item_MaxOnhand,
      ap_code: item.AP_Code,
      item_gold: item.Item_Gold,
      item_onhand: item.Item_Onhand,
      item_wh: item.WH_Name,
      item_ap_id: item.Item_AP_id,
      item_Spec: item.Item_Spec,
      is_bom: item.Is_BOM,
      is_sub_item: item.Is_Sub_Item,
      show_spec: item.Is_Spec_Show,
      item_qty_in: item.Item_Qty_IN,
      item_qty_st: item.Item_Qty_ST,
      item_qty_out: item.Item_Qty_OUT,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลสินค้า"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลสินค้า"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  setSelectedData={setSelectedData}
                  setMode={setMode}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetItem;
